import { Component, OnInit, Output } from '@angular/core';
import { Orgstyle } from '../orgaccount/orgstyle/model/orgstyle';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { AuthorizationService } from '@src/app/helpers/authorization.service';
import { Router } from '@angular/router';
import { Meta } from '@angular/platform-browser';


import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy({ checkProperties: true })
@Component({
  selector: 'app-people',
  templateUrl: './people.component.html',
  styleUrls: ['./people.component.css']
})
export class PeopleComponent implements OnInit {
  acceptedJoiner:any;
  @Output() orgstyle:Orgstyle;

  constructor(
    private authservice:AuthorizationService,
    private router:Router,
    private meta:Meta,
    ) { }

  ngOnInit() {
    this.meta.addTags([
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' },
    ]);   
    if(!this.authservice.isAuthorized('org_edit',SessionHelper.getChoosenOrg())){
      this.router.navigate(['/portal']);
    }
    this.orgstyle = new Orgstyle;
    this.orgstyle.sidenav = 'top';
    if(SessionHelper.getDynamicStyle() && SessionHelper.getDynamicStyle() !== 'undefined' ){
      this.orgstyle = JSON.parse(SessionHelper.getDynamicStyle());
    }
  }
  joinerToAdd($event){
    this.acceptedJoiner = $event;

  }
}
